import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATALOG_OCCASIONS } from "@/lib/products";

// Replaces the old homepage "Section 03 · Catalog" grid (which duplicated
// Section 01 · Personalize almost 1:1 whenever the admin catalog is empty).
// Curated occasion cards route to /catalog?occasion=<slug>, a lighter-weight
// entry point than listing every product twice.
export default function ShopByOccasionSection() {
  return (
    <section id="occasions" className="relative py-24 md:py-32 border-t border-white/5" data-testid="occasion-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-2xl">
          <div className="text-xs tracking-widest-2 uppercase text-[#d4af37]">Section 03 · Shop by Occasion</div>
          <h2 className="mt-4 font-display text-4xl md:text-6xl leading-[1.05] text-white">
            Find the piece for
            <span className="gold-gradient-text italic"> the moment.</span>
          </h2>
          <p className="mt-4 text-white/70 md:text-lg">
            Not sure where to start? Browse our catalog curated by the occasion you're celebrating.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {CATALOG_OCCASIONS.map((o, idx) => (
            <Link
              key={o.slug}
              to={`/catalog?occasion=${o.slug}`}
              className={`group text-left glass glass-hover rounded-3xl overflow-hidden transition duration-500 fade-up fade-up-delay-${Math.min(idx, 3)}`}
              data-testid={`occasion-card-${o.slug}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-black">
                <img
                  src={o.image}
                  alt={o.label}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full glass flex items-center justify-center border border-white/10 group-hover:bg-[#d4af37] group-hover:text-black transition">
                  <ArrowUpRight size={18} />
                </div>
                <div className="absolute bottom-4 left-5 font-display text-2xl md:text-3xl text-white">{o.label}</div>
              </div>
              <div className="p-6 md:p-7">
                <p className="text-sm md:text-base text-white/60 leading-relaxed">{o.description}</p>
                <div className="mt-4 text-xs tracking-widest-2 uppercase text-white/60 group-hover:text-[#d4af37] transition">
                  Shop {o.label} →
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
